module.exports = __webpack_public_path__ + "static/gnome_deep-b31c43db4f5575e05419cbf19f4317cd.jpg";